import React from 'react';

import { Grid, NewTextField as TextField } from '@lp/ds-next';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

export const LPAccountFilters = ({ formik }: { formik: any }) => (
  <>
    <Grid item>
      <TextField
        data-testid="changelog-lpaccount-id-filter"
        label="Account ID"
        name="lpaccount_id"
        value={formik.values.lpaccount_id}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </Grid>
    <Grid item>
      <TextField
        data-testid="changelog-lpaccount-email-filter"
        label="Account Email"
        name="lpaccount_email"
        value={formik.values.lpaccount_email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </Grid>
    <Grid item>
      <TextField
        data-testid="changelog-created-by-id-filter"
        label="Changed by ID"
        name="created_by_id"
        value={formik.values.created_by_id}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </Grid>
    <Grid item>
      <DatePicker
        data-testid="changelog-created-at-from-filter"
        placeholder="From date"
        style={{ width: '100%' }}
        value={
          formik.values.created_at_from
            ? dayjs(formik.values.created_at_from)
            : null
        }
        onChange={(date: Dayjs | null) => {
          formik.setFieldValue(
            'created_at_from',
            date ? date.startOf('day').format() : ''
          );
        }}
      />
    </Grid>
    <Grid item>
      <DatePicker
        data-testid="changelog-created-at-to-filter"
        placeholder="To date"
        style={{ width: '100%' }}
        value={
          formik.values.created_at_to
            ? dayjs(formik.values.created_at_to)
            : null
        }
        onChange={(date: Dayjs | null) => {
          formik.setFieldValue(
            'created_at_to',
            date ? date.endOf('day').format() : ''
          );
        }}
      />
    </Grid>
  </>
);
